import { useMemo } from 'react';
import { Skeleton } from 'antd';
import RadioFrequencyGirth from './RadioFrequencyGirth';
import ShockwavePainChange from './ShockwavePainChange';
import cx from './index.module.scss';

const CurrentChange = ({
  serviceDetail,
  isGettingData,
  measurementData,
}: {
  isGettingData: boolean;
  serviceDetail: GetServiceOrderDetailResponse;
  measurementData: GetMeasurementResultResponse | GetPainLevelResponse;
}) => {
  const isMorePart = useMemo(() => {
    // 人工\自定义画线\背部 显示两个疼痛等级且分部位
    if (
      serviceDetail?.onlyManual ||
      serviceDetail?.bodyPart === 'Back' ||
      serviceDetail?.bodyPart === 'LowerBody' ||
      serviceDetail?.stepFlow?.find(item => item.step === 'RoboticTask')?.subStep?.includes('CustomPalpation')
    ) {
      return true;
    }
    return false;
  }, [serviceDetail?.bodyPart, serviceDetail?.onlyManual, serviceDetail?.stepFlow]);

  return (
    <div
      className={cx(
        'wrapper',
        { 'shockwave-more-part-wrapper': serviceDetail?.itemType?.includes('Shockwave') && isMorePart },
        {
          'shockwave-only-part-wrapper': serviceDetail?.itemType?.includes('Shockwave') && !isMorePart,
        }
      )}
    >
      <Skeleton loading={isGettingData} paragraph={{ rows: 1 }} title={false}>
        {serviceDetail?.itemType?.includes('Shockwave') ? (
          <ShockwavePainChange
            serviceDetail={serviceDetail}
            beforeHandData={(measurementData as GetPainLevelResponse)?.before}
            afterHandData={(measurementData as GetPainLevelResponse)?.after}
            orderTypeIsCommon={isMorePart}
          />
        ) : (
          <RadioFrequencyGirth
            serviceDetail={serviceDetail}
            beforeHandData={(measurementData as GetMeasurementResultResponse)?.before}
            afterHandData={(measurementData as GetMeasurementResultResponse)?.after}
          />
        )}
      </Skeleton>
    </div>
  );
};

export default CurrentChange;
